import styled from "styled-components";
import {SpinnerBackgroundDefaultBox} from "./spinner-background.default.box";

export const SpinnerBackgroundCISBox = styled(SpinnerBackgroundDefaultBox)`
  background-position: -1253px -318px;
  border-radius: 50%;
`;